// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2USNs","header":"PatientBlock_header__-H1K6","label":"PatientBlock_label__3lozq","option":"PatientBlock_option__3cdca"};